import * as angular from 'angular';

@Service('ib-commons-proxies-module', ['$http', '$q', '$rootScope'])
export class CommonsGenericProxy {
    DIC_Headers: object;
    constructor (private $http: ng.IHttpService, private $q: ng.IQService, private $rootScope: CommonsRootScope) {
        this.DIC_Headers = {
            'Accept-Language': this.$rootScope.appLang
        };
    }

    ////////////////
    /**
     * Calls HTTP GET method
     * @param {string} url - the http url of ignore order rest service
     * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
     *  When the promise rejects, it returns an object with the response error data and the response error code.
     */



    getGeneric = (url: string, type?: string, maxTimeout?: number, newConfig?: CommonsGenerateUrlModel.headerConfig): ng.IPromise<CommonsServiceTypes.CommonsProxyResponse | CommonsServiceTypes.CommonsErrorProxyResponse> => {
        const defer = this.$q.defer();
        let configObj: ng.IRequestShortcutConfig = {timeout: maxTimeout};
        const getComplete = (response: CommonsServiceTypes.CommonsProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.resolve({ data: response.data, code: response.status });
        };
        const getFailed = (response: CommonsServiceTypes.CommonsErrorProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.reject({ data: response.data, errorCode: response.status, requestURL: (response.config && response.config.url)? response.config.url: ''});
        };
        const config: any = type === 'dict' ? { method: 'GET', url: url, headers: {'Accept-Language': this.$rootScope.appLang}, timeout: maxTimeout } : { method: 'GET', url: url, timeout: maxTimeout};
        config;
        
        if (newConfig) {
            // if (newConfig.headers['Cache-Control'] && newConfig.headers['Cache-Control'].indexOf('no-cache') === -1 && newConfig.headers['Cache-Control'].indexOf('no-store') === -1) this.$http.defaults.cache = true;
            config.headers = newConfig.headers;
            this.$http.defaults.withCredentials = false;
            this.$http(config)
                .then(getComplete).catch(getFailed);
        } else {
            this.$http(config)
                .then(getComplete).catch(getFailed);
        }
        
        return defer.promise;
    };


    ////////////////
    /**
     * Calls HTTP POTS method
     * @param {string} url - the http url of ignore order rest service
     * @param {data} data - data to send to rest service
     * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
     *  When the promise rejects, it returns an object with the response error data and the response error code.
     */

    
    postGeneric = (url: string, data: object, newConfig?: CommonsGenerateUrlModel.headerConfig, maxTimeout?: number): angular.IPromise<CommonsServiceTypes.CommonsProxyResponse | CommonsServiceTypes.CommonsErrorProxyResponse> => {
        const defer = this.$q.defer();
        let configObj: ng.IRequestShortcutConfig = {timeout: maxTimeout};
        const postComplete = (response: CommonsServiceTypes.CommonsProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.resolve({ data: response.data, code: response.status });
        };
        const postFailed = (response: CommonsServiceTypes.CommonsErrorProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.reject({ data: response.data, errorCode: response.status, requestURL: (response.config && response.config.url)? response.config.url: '' });
        };
        if (newConfig) {
            if(data['person']) {
                const wifiHeader = {'transaction-channel': data['person'].sourceName};
                configObj.headers = wifiHeader; 
            }else {
                configObj.headers = newConfig.headers;
                this.$http.defaults.withCredentials = false;
            }
            this.$http.post(url, angular.toJson(data), configObj)
                .then(postComplete).catch(postFailed);
            return defer.promise;
        } else {
            this.$http.post(url, angular.toJson(data))
                .then(postComplete).catch(postFailed);
            return defer.promise;
        }
    };


    ////////////////
    /**
     * Calls HTTP DELETE method to ignore order rest service
     * @param {string} url - the http url of ignore order rest service
     * @param {data} data - data to send to rest service
     * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
     *  When the promise rejects, it returns an object with the response error data and the response error code.
     */
    putGeneric = (url: string, data: object, newConfig?: CommonsGenerateUrlModel.headerConfig, maxTimeout?: number): angular.IPromise<CommonsServiceTypes.CommonsProxyResponse | CommonsServiceTypes.CommonsErrorProxyResponse> => {
        const defer = this.$q.defer();
        let configObj: ng.IRequestShortcutConfig = {timeout: maxTimeout};
        const putComplete = (response: CommonsServiceTypes.CommonsProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.resolve({ data: response.data, code: response.status });
        };

        const putFailed = (response: CommonsServiceTypes.CommonsErrorProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.reject({ data: response.data, errorCode: response.status, requestURL: (response.config && response.config.url)? response.config.url: '' });
        };
        if (newConfig) {
            configObj.headers = newConfig.headers;
            this.$http.defaults.withCredentials = false;
            this.$http.put(url, angular.toJson(data), configObj)
                .then(putComplete).catch(putFailed);
        } else {
            this.$http.put(url, angular.toJson(data), configObj)
                .then(putComplete).catch(putFailed);
        }
        return defer.promise;
    };

    ////////////////
    /**
     * Calls HTTP DELETE method to ignore order rest service
     * @param {string} url - the http url of ignore order rest service
     * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
     *  When the promise rejects, it returns an object with the response error data and the response error code.
     */
    deleteGeneric = (url: string, newConfig?: CommonsGenerateUrlModel.headerConfig, maxTimeout?: number): angular.IPromise<CommonsServiceTypes.CommonsProxyResponse | CommonsServiceTypes.CommonsErrorProxyResponse> => {
        const defer = this.$q.defer();
        let configObj: ng.IRequestShortcutConfig = {timeout: maxTimeout};
        const deleteComplete = (response: CommonsServiceTypes.CommonsProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.resolve({ data: response.data, code: response.status });
        };
        const deleteFailed = (response: CommonsServiceTypes.CommonsErrorProxyResponse): void => {
            this.$http.defaults.withCredentials = true;
            return defer.reject({ data: response.data, errorCode: response.status, requestURL: (response.config && response.config.url)? response.config.url: ''});
        };
        if (newConfig) {
            configObj.headers = newConfig.headers;
            this.$http.defaults.withCredentials = false;
            this.$http.delete(url, configObj)
                .then(deleteComplete).catch(deleteFailed);
        } else {
            this.$http.delete(url, configObj)
                .then(deleteComplete).catch(deleteFailed);
        }
        return defer.promise;
    };



    ////////////////
    /**
     * Calls HTTP PATCH method
     * @param {string} url - the http url of ignore order rest service
     * @param {data} data - data to send to rest service
     * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
     *  When the promise rejects, it returns an object with the response error data and the response error code.
     */
    patchGeneric = (url: string, data: any, maxTimeout?: number): angular.IPromise<CommonsServiceTypes.CommonsProxyResponse | CommonsServiceTypes.CommonsErrorProxyResponse> => {
        const defer = this.$q.defer();
        const config = {timeout: maxTimeout};
        const patchComplete = (response: CommonsServiceTypes.CommonsProxyResponse): void => {
            return defer.resolve({ data: response.data, code: response.status });
        };

        const patchFailed = (response: CommonsServiceTypes.CommonsErrorProxyResponse): void => {
            return defer.reject({ data: response.data, errorCode: response.status, requestURL: (response.config && response.config.url)? response.config.url: ''  });
        };
        this.$http.patch(url, angular.toJson(data), config)
            .then(patchComplete).catch(patchFailed);
        return defer.promise;
    };


}
